import axios, { AxiosError } from 'axios'
import Config from '../config'
import StoreService from '../redux/StoreService'
import { accessTokenSelector } from '../redux/auth/authSelectors'
import { logOut } from '../redux/auth/authActions'
import uuidv4 from 'uuid/v4'

const instance = axios.create({
  baseURL: Config.ENDPOINT_DOMAIN,
  timeout: 60000,
  headers: { 'x-correlation-id': uuidv4() },
})

instance.defaults.headers.common.apikey = Config.KONG_APIKEY

instance.interceptors.request.use(
  config => {
    const store = StoreService.getStoreReference()
    const token = accessTokenSelector(store.getState())

    if (!token) {
      return config
    }

    // TODO: Decide what to do with headers
    config.headers['accept-language'] = 'en-US'
    config.headers['Access-Control-Allow-Origin'] = '*'

    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  error => Promise.reject(error)
)

instance.interceptors.response.use(
  response => {
    return response
  },
  (error: AxiosError) => {
    if (error.response.status === 401) {
      StoreService.dispatch(logOut())
    }
    return Promise.reject(error)
  }
)

export default instance
